import { render, staticRenderFns } from "./CampaignItem.vue?vue&type=template&id=d3e2d680&scoped=true&"
import script from "./CampaignItem.vue?vue&type=script&lang=js&"
export * from "./CampaignItem.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItem.vue?vue&type=style&index=0&id=d3e2d680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e2d680",
  null
  
)

export default component.exports